

















import { computed, defineComponent } from '@vue/composition-api';
import { useOfflineMapAsyncState } from '@/store/modules/offlineMaps';

export default defineComponent({
	props: {
		fieldId: {
			type: String,
			required: true,
		},
		showCaption: {
			type: Boolean,
			default: true,
		},
	},
	setup(props, { root }) {
		const offlineMapAsyncState = computed(() => useOfflineMapAsyncState(root.$store)(props.fieldId));
		const disabled = computed(() => offlineMapAsyncState.value.isLoading || offlineMapAsyncState.value.isLoaded);

		const handleClick = (ev: MouseEvent | TouchEvent) => {
			ev.preventDefault();
			ev.stopPropagation();
			if (!offlineMapAsyncState.value.isLoading && !offlineMapAsyncState.value.isLoaded) {
				root.$store.dispatch('offlineMaps/fetchOfflineMap', props.fieldId);
			}
		};

		return {
			disabled,
			handleClick,
			offlineMapAsyncState,
		};
	},
});
